import { z } from 'zod'
import { DERIVED_BUCKETS } from '@autoriz/shared/assistant'

export type { DerivedBucket } from '@autoriz/shared/assistant'

// Runtime bucket for rendering: the four derived buckets from @autoriz/shared
// plus `ignored` (orthogonal, driven by dismissed_at). Set by the fetch layer
// after deriving from `target_time` and `dismissed_at` (FR-035, FR-038).
export const TaskBucketSchema = z.enum([...DERIVED_BUCKETS, 'ignored'])
export type TaskBucket = z.infer<typeof TaskBucketSchema>

export const TaskSourceSchema = z.enum(['auto', 'manual'])
export type TaskSource = z.infer<typeof TaskSourceSchema>

export const TaskSchema = z.object({
  id: z.string().uuid(),
  projectId: z.number().int().nullable(),
  kind: z.string().min(1),
  source: TaskSourceSchema,
  title: z.string().min(1).max(240),
  reason: z.string().nullable(),
  meta: z.string().nullable(),
  actionLabelOverride: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  visibleFrom: z.string(),
  targetTime: z.string(),
  dismissedAt: z.string().nullable(),
  completedAt: z.string().nullable(),
  bucket: TaskBucketSchema,
  client: z.string().nullable(),
  projectType: z.string().nullable(),
})
export type Task = z.infer<typeof TaskSchema>

export const TaskListSchema = z.array(TaskSchema)
